(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upvine-ad-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('upvine-ad-offer')) {
    customElements.define('upvine-ad-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.link = this.querySelector('[data-apply]');
        this.countdown = this.querySelector('[data-countdown]');
        this.endpoint = (this.dataset.endpoint || '').replace(/\/$/, '');
        this.claimStatus = this.querySelector('[data-claim-status]');
        this.banner = this.querySelector('[data-offer-banner]');
        this.bannerClock = this.banner?.querySelector('[data-banner-clock]');
        if (this.banner) document.body.prepend(this.banner);
        this.params = new URLSearchParams(location.search);
        this.preview = this.dataset.preview === 'true' && this.params.get('upvine_offer_preview') === '1';
        this.key = 'upvine-offer-v2-' + this.dataset.code;
        this.sessionKey = this.key + '-session';
        this.claimKey = this.key + '-claimed';
        this.source = this.adSource(this.params);
        this.state = { elapsed: 0, source: '', touched: Date.now(), shown: false, shownAt: 0, claimed: false };
        this.abort = new AbortController();
        this.lastTick = performance.now();
        if (this.dataset.preview === 'true' && this.params.get('upvine_offer_reset') === '1') {
          this.resetPreview(); return;
        }
        const signal = this.abort.signal;
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        const redirect = new URL(location.href);
        redirect.searchParams.delete('upvine_offer_preview');
        redirect.searchParams.delete('upvine_offer_claimed');
        this.returnPath = redirect.pathname + redirect.search + redirect.hash;
        this.link.href = this.endpoint ? '#' : root + 'discount/' + encodeURIComponent(this.dataset.code) + '?redirect=' + encodeURIComponent(redirect.pathname + redirect.search + redirect.hash);
        this.querySelectorAll('[data-dismiss]').forEach(button => button.addEventListener('click', () => this.dismiss(true, button.dataset.dismiss === 'decline' ? 'decline' : 'close'), { signal }));
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, { signal });
        this.link.addEventListener('click', event => {
          if (this.endpoint) { event.preventDefault(); this.claimOffer(); return; }
          this.dataset.lastAction = 'claim';
          this.state.claimed = true;
          try { sessionStorage.setItem(this.claimKey, String(Date.now() + 7 * 86400000)); } catch {}
          this.save();
          this.track('claim');
          this.dismiss(false);
        }, { signal });
        document.addEventListener('click', event => this.buyNow(event), { capture: true, signal });
        document.addEventListener('visibilitychange', () => { this.lastTick = performance.now(); this.save(); }, { signal });
        window.addEventListener('pagehide', () => this.save(), { signal });
        document.addEventListener('visitorConsentCollected', () => {
          if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
            this.analyticsState = null;
            try { sessionStorage.removeItem(this.sessionKey + '-analytics-' + (this.dataset.preview === 'true' ? 'preview' : 'production')); } catch {}
          }
          if (!this.allowed()) {
            try { sessionStorage.removeItem(this.sessionKey); localStorage.removeItem(this.key); } catch {}
            if (this.dialog.open) this.dismiss(false);
            this.loaded = false;
          }
        }, { signal });
        if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
        }
        this.timer = setInterval(() => this.tick(), 250);
        if (this.endpoint) this.restoreClaim();
      }
      async resetPreview() {
        try {
          const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
          const result = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:''})});
          if (!result.ok) throw new Error('Cart discount reset failed');
          for (const storage of [localStorage, sessionStorage]) {
            for (const key of [this.key,this.sessionKey,this.sessionKey + '-analytics-' + (this.dataset.preview === 'true' ? 'preview' : 'production'),this.claimKey,'upvine-offer-visitor','upvine-issued-offer','upvine-offer-receipt']) storage.removeItem(key);
          }
          const target = new URL(location.href);
          target.searchParams.delete('upvine_offer_reset');
          target.searchParams.delete('upvine_offer_claimed');
          target.searchParams.set('upvine_offer_preview','1');
          location.replace(target.pathname + target.search + target.hash);
        } catch { this.dataset.resetError = 'Unable to reset preview'; }
      }
      async offerRequest(path, visitor) {
        const result = await fetch(this.endpoint + path, {
          method: 'POST', mode: 'cors', credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ visitor }), signal: AbortSignal.timeout(20000)
        });
        if (result.status === 410) return { status: 'inactive' };
        if (result.status !== 200) throw new Error('Offer unavailable');
        return result.json();
      }
      acceptClaim(claim) {
        if (!/^[A-Z0-9]{6,16}$/.test(claim.code || '') || !this.setIssuedExpiry(claim.expiresAt, claim.serverNow)) return false;
        this.claim = claim;
        this.updateBanner();
        this.state.claimed = true;
        this.dataset.claimExpiresAt = claim.expiresAt;
        localStorage.setItem('upvine-issued-offer', JSON.stringify(claim));
        this.claimStatus.textContent = this.claimStatus.dataset.success + ' ' + claim.code;
        return true;
      }
      async restoreClaim() {
        if (this.statusPending) return;
        this.statusPending = true;
        this.nextStatusCheck = performance.now() + 60000;
        try {
          const visitor = localStorage.getItem('upvine-offer-visitor');
          if (!visitor) { this.nextStatusCheck = Infinity; return; }
          const claim = await this.offerRequest('/status', visitor);
          if (claim.status === 'claimed' && this.acceptClaim(claim)) {
            sessionStorage.removeItem('upvine-offer-receipt');
          } else {
            localStorage.removeItem('upvine-issued-offer'); this.claim = null;
            this.nextStatusCheck = Infinity;
            this.updateBanner();
          }
        } catch { this.claim = null; this.updateBanner(); }
        finally { this.statusPending = false; }
      }
      async claimOffer() {
        if (this.claiming) return;
        this.track('claim_click');
        this.claiming = true;
        if (this.dialog?.open) this.dismiss(false);
        this.link.setAttribute('aria-busy', 'true');
        this.claimStatus.textContent = this.claimStatus.dataset.loading;
        try {
          let visitor = localStorage.getItem('upvine-offer-visitor');
          if (!visitor) {
            visitor = Array.from(crypto.getRandomValues(new Uint8Array(32)), b => b.toString(16).padStart(2, '0')).join('');
            localStorage.setItem('upvine-offer-visitor', visitor);
          }
          const claim = await this.offerRequest('/claim', visitor);
          if (!this.acceptClaim(claim)) throw new Error('Invalid offer');
          this.save();
          this.track('claim');
          const redirect = new URL(this.returnPath, location.origin);
          const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
          location.assign(root + 'discount/' + encodeURIComponent(claim.code) + '?redirect=' + encodeURIComponent(redirect.pathname + redirect.search + redirect.hash));
        } catch {
          this.claimStatus.textContent = this.claimStatus.dataset.error;
          if (this.dialog && !this.dialog.open) this.show();
        }
        finally { this.claiming = false; this.link.removeAttribute('aria-busy'); }
      }
      updateBanner() {
        if (!this.banner) return;
        const remaining = this.claim && Number.isFinite(this.countdownDeadline) ? Math.max(0, Math.ceil((this.countdownDeadline - performance.now()) / 1000)) : 0;
        this.banner.hidden = !remaining;
        document.documentElement.classList.toggle('upvine-offer-banner-active', Boolean(remaining));
        if (remaining) this.bannerClock.textContent = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60].map(value => String(value).padStart(2, '0')).join(':');
      }
      setIssuedExpiry(expiresAt, serverNow) {
        const expiry = Date.parse(expiresAt);
        const issuedNow = Date.parse(serverNow);
        if (!Number.isFinite(expiry) || !Number.isFinite(issuedNow) || expiry <= issuedNow || expiry - issuedNow > 86400000) return false;
        this.countdownDeadline = performance.now() + (expiry - issuedNow);
        this.updateCountdown();
        return true;
      }
      updateCountdown() {
        this.updateBanner();
        if (!this.countdown || !Number.isFinite(this.countdownDeadline)) return;
        const remaining = Math.max(0, Math.ceil((this.countdownDeadline - performance.now()) / 1000));
        const values = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        ['hours', 'minutes', 'seconds'].forEach((part, index) => {
          this.countdown.querySelector('[data-' + part + ']').textContent = String(values[index]).padStart(2, '0');
        });
        this.countdown.querySelector('[data-countdown-label]').textContent = remaining ? this.countdown.dataset.activeLabel : this.countdown.dataset.expiredLabel;
      }
      adSource(params) {
        if (['gclid', 'gbraid', 'wbraid'].some(key => params.get(key)?.trim())) return 'google';
        const source = (params.get('utm_source') || '').toLowerCase();
        const medium = (params.get('utm_medium') || '').toLowerCase();
        return ['google', 'bing', 'microsoft', 'facebook', 'instagram', 'meta', 'tiktok', 'pinterest', 'youtube'].includes(source) && ['cpc', 'ppc', 'paid', 'paid_social', 'paid-social', 'paid_search', 'display', 'cpm'].includes(medium) ? source : '';
      }
      buyNow(event) {
        const button = event.target.closest?.('.shopify-payment-button__button--unbranded');
        if (!button || button.disabled) return;
        if (this.endpoint) { if (!this.claim || this.countdownDeadline <= performance.now()) return; }
        else { try { if (Number(sessionStorage.getItem(this.claimKey)) <= Date.now()) return; } catch { return; } }
        const form = button.closest('form');
        if (!form || !form.checkValidity()) return;
        const data = new FormData(form);
        const variant = String(data.get('id') || '');
        const quantity = Number(data.get('quantity') || 1);
        if (!/^\d+$/.test(variant) || !Number.isSafeInteger(quantity) || quantity < 1 || data.get('selling_plan')) return;
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        const target = new URL(root + 'cart/' + variant + ':' + quantity, location.origin);
        target.searchParams.set('discount', this.endpoint ? this.claim.code : this.dataset.code);
        const properties = {};
        for (const [key, value] of data) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string' && value) properties[match[1]] = value;
          if (match && typeof value !== 'string' && value.size) return;
        }
        if (Object.keys(properties).length) target.searchParams.set('properties', btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(properties)))).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', ''));
        if (this.dataset.preview === 'true' && window.Shopify?.theme?.id) target.searchParams.set('preview_theme_id', window.Shopify.theme.id);
        event.preventDefault();
        event.stopImmediatePropagation();
        location.assign(target.href);
      }
      allowed() {
        const privacy = window.Shopify?.customerPrivacy;
        return privacy?.marketingAllowed?.() === true && privacy?.preferencesProcessingAllowed?.() === true;
      }
      read(storage, key) {
        try { return JSON.parse(storage.getItem(key) || 'null'); } catch { return null; }
      }
      load() {
        this.loaded = true;
        try {
          const saved = this.read(sessionStorage, this.sessionKey);
          if (saved && Date.now() - saved.touched < 30 * 60 * 1000 && Number.isFinite(saved.elapsed)) this.state = saved;
          this.state.source = this.state.source || this.source;
        } catch { this.state.source = this.source; }
      }
      save() {
        if (this.preview || !this.allowed() || !this.state.source) return;
        this.state.touched = Date.now();
        try { sessionStorage.setItem(this.sessionKey, JSON.stringify(this.state)); } catch {}
      }
      track(action, visitSource) {
        if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
        const mode = this.dataset.preview === 'true' ? 'preview' : 'production';
        const source = visitSource || this.state.source || this.source || 'unknown';
        if (this.endpoint) {
          try {
            const body = JSON.stringify({id:crypto.randomUUID(),action,mode,source});
            fetch(this.endpoint + '/events', {method:'POST',mode:'cors',credentials:'omit',keepalive:true,headers:{'Content-Type':'application/json'},body}).catch(() => {});
          } catch {}
        }
        if (mode === 'preview') return;
        const detail = { event: 'upvine_offer_' + action, offer_source: source };
        if (Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
        document.dispatchEvent(new CustomEvent('upvine:offer', { detail }));
      }
      analyticsVisit(action = 'ad_entry') {
        // Separate from marketing eligibility: count consented advertising visits even in cooldown.
        if (this.preview || window.Shopify?.designMode || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
        const key = this.sessionKey + '-analytics-' + (this.dataset.preview === 'true' ? 'preview' : 'production');
        const now = Date.now();
        if (!this.analyticsState) {
          const saved = this.read(sessionStorage, key);
          this.analyticsState = saved && now - saved.touched < 30 * 60 * 1000 ? saved : { source: this.source, touched: now };
        }
        const visit = this.analyticsState;
        if (!visit.source) visit.source = this.source;
        if (!visit.source) return;
        if (!visit[action] && (action === 'ad_entry' || visit.ad_entry)) {
          visit[action] = true;
          this.track(action, visit.source);
        }
        if (document.visibilityState === 'visible' && document.hasFocus()) visit.touched = now;
        try { sessionStorage.setItem(key, JSON.stringify(visit)); } catch {}
      }
      busy() {
        return [...document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer.active, .popup-open, #shopify-pc__banner')].some(el => {
          if (el === this.dialog || this.contains(el) || el.closest('details:not([open]), [aria-hidden="true"], [hidden]')) return false;
          const rect = el.getBoundingClientRect();
          const style = getComputedStyle(el);
          return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
        });
      }
      tick() {
        this.analyticsVisit();
        this.updateCountdown();
        const now = performance.now();
        const delta = Math.min(now - this.lastTick, 1000);
        this.lastTick = now;
        if (document.visibilityState !== 'visible' || !document.hasFocus()) return;
        if (this.endpoint && now >= this.nextStatusCheck) this.restoreClaim();
        if (this.preview) {
          if (!this.state.shown && !this.busy()) this.show();
          return;
        }
        if (window.Shopify?.designMode || !this.allowed()) return;
        if (!this.loaded) this.load();
        if (this.state.shown && Date.now() - this.state.shownAt >= Number(this.dataset.days) * 86400000) {
          this.state.shown = false;
          this.state.claimed = false;
          this.state.elapsed = 0;
        }
        if (!this.state.source || this.state.shown || this.state.claimed) return;
        if (['cart', 'checkout', 'customers/account', 'customers/login', 'password'].includes(this.dataset.page)) return;
        try {
          const until = this.read(localStorage, this.key);
          if (Number(until) > Date.now()) return;
        } catch {}
        if (!this.statusPending && !this.claim) this.analyticsVisit('eligible_entry');
        this.state.elapsed += delta;
        this.save();
        if (this.state.elapsed >= Number(this.dataset.delay) * 1000 && !this.busy()) this.show();
      }
      show() {
        if (typeof this.dialog.showModal !== 'function') return;
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.link.focus({ preventScroll: true });
        this.state.shown = true;
        this.state.shownAt = Date.now();
        if (!this.preview && this.allowed()) {
          try { localStorage.setItem(this.key, JSON.stringify(Date.now() + Number(this.dataset.days) * 86400000)); } catch {}
        }
        this.save();
        this.track('view');
        if (this.analyticsState?.eligible_entry) this.analyticsVisit('eligible_view');
      }
      dismiss(log = true, reason = 'close') {
        this.dataset.lastAction = log ? 'dismiss' : 'claim';
        if (!this.dialog.open) return;
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.previousFocus?.focus?.({ preventScroll: true });
        if (log) this.track(reason);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.banner?.remove();
        document.documentElement.classList.remove('upvine-offer-banner-active');
        this.dismiss(false);
        this.abort?.abort();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
